<template>
  <div class="detail">
    <!-- <div class="detailCommorCont crumbs"><a href="/">Home</a>>Highlights</div> -->
    <!-- 内容 -->
    <div class="detailCommorCont sectionContent">
      <!--  内容-左侧-->
      <div class="wrapLeft">
        <h1 class="article-title">{{ title }}</h1>
        <div class="article-info">
          <span class="time">{{ day }}</span>
          <span class="source" v-if="source != ''">来源：{{ source }}</span>
        </div>
        <!-- 播放器 -->
        <!-- 音频类型新闻 -->
        <div class="audio-player" v-if="categoryId == 0 && mediaUrl != ''">
          <audio
            id="js-preview-player"
            class="js-detail-audio-player"
            controls=""
            preload="auto"
            :src="mediaUrl"
            type="audio/mpeg"
            @play="closeGlobalPlayer"
          ></audio>
        </div>
        <!-- 视频直播类型 -->
        <section v-if="(categoryId == 1 || categoryId == 7 || categoryId == 9) && mediaUrl != ''">
          <div class="live-video-player" v-if="mediaUrlSuffix == 'm3u8'">
            <video class="video-js" controls="" :poster="programUrl" id="js-live-video-player">
              <source :src="mediaUrl" type="application/x-mpegURL">
            </video>
          </div>
          <div class="video-player" id="js-video-player" v-else>
            <video :src="mediaUrl" controls="" type="video/mp4" class="js-detail-video-player" @play="closeGlobalPlayer">
            </video>
          </div>
        </section>
        <!-- 音频直播类型 -->
        <div class="live-audio-player" v-if="categoryId == 6 && mediaUrl != ''">
          <audio class="video-js" id="js-live-audio-player">
            <source :src="mediaUrl" type="application/x-mpegURL">
          </audio>
        </div>
        <div class="article-summary">{{info}}</div>
        <div class="article-content" v-html="removeHtmlStyle(context)">
          {{ context }}
        </div>
        <!-- 分享 -->
        <div class="widget-share">
          <strong>分享至：</strong>
          <a href="javascript:void(0)" class="weixin" @click.stop.prevent="" @click="isWxCode = !isWxCode"></a>
          <a :href="wbShareLink" class="weibo" target="_blank"></a>
          <a :href="qqShareLink" class="qq" target="_blank"></a>
          <div class="code wxCode" id="qrcode" ref="qrcode" v-show="isWxCode">
          </div>
        </div>
        <!-- 评论相关 -->
        <div class="comment">
          <h2 class="column-title column-title-id" data-programid="1323">
            Featured Comments
          </h2>
          <div class="comment-list">
            <!-- list -->
            <div
              class="comment-list-item"
              v-for="(item, index) in allList"
              :key="index"
            >
              <div class="comment-list-img">
                <img :src="item.userPic" alt="" />
              </div>
              <div class="comment-list-txt">
                <span class="title">{{ item.userName }}</span>
                <p>{{ item.content }}</p>
                <div class="info">
                  <span class="time">{{ item.createTime }}</span>
                </div>
              </div>
            </div>
            <div
              class="more"
              v-if="allList.length >= pageSize && moreBtnShow"
              @click="getMore()"
            >
              more
            </div>
            <div class="comment-list-item" v-if="hide">
              <p>暂无评论</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容右侧 -->
      <div class="wrapRight">
        <div class="spread" v-if="adImageUrl">
          <img :src="adImageUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import videojs from 'video.js'
export default {
  name: "Detail",
  data() {
    return {
      moreBtnShow: true,
      msg: "detail",
      programId: 1331,
      type: "",
      // 第一个接口 页面展示data
      programUrl: "",
      mediaUrl: "",
      title: "",
      context: "",
      info:"",
      author: "",
      day: "",
      source: "",
      // 第二个 评论接口  展示数据
      origin: "", //type
      // episodeId: "253476", //programId

      pageSize: 5,

      //分页
      totalRow: 0,
      pageNumber: 1,
      // pageSize: "",
      allList: "",
      objzidian: {
        ezfm: 1,
        ezfmSelection: 2,
        recommend: 3,
        more: 4,
        other: 5,
        otherSelection: 6,
        otherHistory: 5,
        ezfmHistory: 1,
      },
      //右侧图片
      adImageUrl: "",
      adInfoUrl: "",
      title: "",
      hide: false,
      typeName: "",
      // 分享链接
      qqShareLink:'',
      wbShareLink:'',
      curPageLink:window.location.href,
      isWxCode:false,
      categoryId:0,
      videoLivePlayer:null,
      audioLivePlayer:null,
    };
  },
  methods: {
    getImgdetail() {
      var _this = this;

      _this.programId = parseInt(_this.$route.params.newsId);
      //  _this.typeName=_this.$route.params.type;
      _this.type = _this.objzidian[_this.$route.params.type + ""];

      // 请求接口传参 https://aezfm.meldingcloud.com/program/onAir?programId=252862&type=1
      _this.$http
        .post("/qertyuiy/program/onAir?programId="+_this.programId+"&type="+_this.type)
        .then(function (res) {
          //右侧广告图片
          _this.adImageUrl = res.data.data.adImageUrl;
          //Y右侧广告url
          _this.adInfoUrl = res.data.data.adInfoUrl;
          //右侧图片 title
          _this.title = res.data.data.title;
          // _this.number = res.data.data.programId;
          document.title = _this.title;
          $("meta[name='description']").attr('content',''+res.data.data.info+'');
        });
    },
    getMore() {
      this.getComentList();
    },

    getComentList() {
      //https://aezfm.meldingcloud.com/v2/message?origin=ezfm&episodeId=253476&sessionId=8295f0a6-6804-4d61-8944-4f8d60a71cd4&page=1&pageSize=30
      //https://aezfm.meldingcloud.com/v2/message?origin=ezfm&episodeId=253470&sessionId=8295f0a6-6804-4d61-8944-4f8d60a71cd4&page=1&pageSize=3
      var _this = this;

      // "/qertyuiy/v2/message?origin=ezfm&episodeId=253470&sessionId=8295f0a6-6804-4d61-8944-4f8d60a71cd4&page=" +
      //   _this.pageNumber +
      //   "&pageSize=3"

      //
      var type = _this.$route.params.type;
      if (type == "otherHistory") {
        type = "other";
      } else if (type == "ezfmHistory") {
        type = "ezfm";
      }

      _this.$http
        .get("/qertyuiy/v2/message?&origin="+type+"&episodeId="+_this.programId+"&page="+_this.pageNumber+"&pageSize="+ _this.pageSize)
        .then(function (res) {
          var arr = [];
          if (_this.pageNumber == 1) {
            _this.allList = res.data.episodeMessage;
            if (_this.allList.length == "0") {
              _this.hide = true;
            }
          } else {
            var arr = res.data.episodeMessage;
            if (arr.length < _this.pageSize) {
              _this.moreBtnShow = false;
            }
            _this.allList = _this.allList.concat(arr);
          }
          _this.pageNumber++;
        });
    },

    getList() {
      //https://aezfm.meldingcloud.com/program/onAir?programId=1331&type=3
      var _this = this , first = '';
      _this.programId = parseInt(_this.$route.params.newsId);

      _this.type = _this.objzidian[_this.$route.params.type + ""];
      _this.$http
        .post("/qertyuiy/program/onAir?&programId="+_this.programId+"&type="+_this.type)
        .then(function (res) {
          _this.programUrl = res.data.data.programUrl;
          _this.mediaUrl = res.data.data.mediaUrl;
          first = res.data.data.mediaUrl.lastIndexOf(".");
          _this.mediaUrlSuffix = res.data.data.mediaUrl.substring(first + 1,res.data.data.mediaUrl.length);
          _this.title = res.data.data.title;
          _this.context = res.data.data.context;
          _this.info = res.data.data.info;
          _this.author = res.data.data.author;
          _this.day = res.data.data.day;
          _this.source = res.data.data.source;
          _this.categoryId = res.data.data.categoryId;
          _this.qqShareLink = 'http://connect.qq.com/widget/shareqq/index.html?title='+_this.title+'&pics='+_this.programUrl+'&url='+_this.curPageLink+'';
          _this.wbShareLink = 'http://service.weibo.com/share/share.php?title='+_this.title+'&pic='+_this.programUrl+'&url='+_this.curPageLink+'';
          _this.videoLiveInit();
          _this.audioLiveInit();
        });
    },
    // 生成二维码
    wxCode:function(){
      var _this = this;
      _this.qrcode = new QRCode('qrcode', {
        text:_this.curPageLink,
        width:100,
        height: 100,
      });
    },
    videoLiveInit:function(){
      var _this = this , _html = '';
      _this.$nextTick(function(){
        if($('#js-live-video-player').length > 0){
          _this.videoLivePlayer = videojs('js-live-video-player',{});
          _this.videoLivePlayer.dispose();
          $('.live-video-player').empty();
          _html = '<video class="video-js" controls="" poster="'+_this.programUrl+'" id="js-live-video-player"><source src="'+_this.mediaUrl+'" type="application/x-mpegURL"></video>';
          $('.live-video-player').append(_html);
          _this.videoLivePlayer = videojs('js-live-video-player',{});
          _this.videoLivePlayer.on('play',function(){
            _this.closeGlobalPlayer();
          })
        }
      })
    },
    audioLiveInit:function(){
      var _this = this , _html;
      _this.$nextTick(function(){
        if($('#js-live-audio-player').length > 0){
          _this.audioLivePlayer = videojs('js-live-audio-player',_this.liveAudioPlayerOptions());
          _this.audioLivePlayer.dispose();
          _html = '<audio class="video-js" id="js-live-audio-player"><source src="'+_this.mediaUrl+'" type="application/x-mpegURL"></audio>';
          $('.live-audio-player').append(_html);
          _this.audioLivePlayer = videojs('js-live-audio-player',_this.liveAudioPlayerOptions());
          _this.audioLivePlayer.on('play',function(){
            _this.closeGlobalPlayer();
          })
        }
      })
    },
    liveAudioPlayerOptions:function(){  //详情页音频直播播放器配置
      var cp_player_options = {   //播放器pcd端配置
          width:784,
          height:60,
          autoplay:false,
          controls:true,
          volumePanel: false,
          bigPlayButton: false,
          textTrackDisplay: false,
          posterImage: false,
          errorDisplay: false,
          controlBar:{
            children:['playToggle','liveDisplay','volumePanel'],
            volumePanel: {
                    inline: false//竖条
                },
          }
      };
      var myOptionsMobile = {  //播放器移动端配置
          controls: true,
          volumePanel: false,
          bigPlayButton: false,
          textTrackDisplay: false,
          posterImage: false,
          errorDisplay: false,
          controlBar: {
              children: ['playToggle', 'liveDisplay']//包含的子元素以及生成顺序
          }
      };
      var _w = document.documentElement.clientWidth;
      return _w < 544 ? myOptionsMobile : cp_player_options;
    },
    closeGlobalPlayer:function(){
      var _this = this , _curPage = $(_this.$parent.$children[3].$el) , _player;
      if(_curPage.attr('class') != 'player'){
        _player = _this.$parent.$children[2].globalPlayer;
      }else{
        _player = _this.$parent.$children[3].globalPlayer;
      }
      _player.pause();
    },
  },
  created() {
    
  },
  mounted(){
    var _this = this;
    this.getList();
    this.getComentList();
    this.getImgdetail();
    this.wxCode();
    $(document).on('click',function(event){
        var _con = $('.weixin');
        if(!_con.is(event.target) && _con.has(event.target).length === 0){ // Mark 1
          _this.isWxCode = false;
        }
    })
  },
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
// 公共
* {
  margin: 0;
  padding: 0;
}

body,
html {
  width: 100%;
  height: 100%;
  background-color: #f3f4f5;
  font-family: "Microsoft YaHei", "\5fae\8f6f\96c5\9ed1", "\5b8b\4f53",
    sans-serif;
}
.detail {
  background: #f3f4f5;
  padding: 15px 0;
}
.detailCommorCont {
  width: 1280px;
  margin: 0 auto;
}
.crumbs {
  font-size: 14px;
  color: #999;
  height: 64px;
  line-height: 54px;
  a {
    font-size: 14px;
    color: #999;
  }
}
.sectionContent {
  display: flex;

  // 左侧内容
  .more {
    width: 134px;
    height: 52px;
    margin: 20px auto 0;
    border-radius: 5px;
    line-height: 52px;
    font-size: 14px;
    background-color: #31a9de;
    color: #fff;
    text-align: center;
  }
  .wrapLeft {
    width: 784px;
    margin-right: 32px;
    .article-title {
      margin-top: 0;
      padding: 0;
      font-size: 26px;
      line-height: 38px;
      font-weight: normal;
    }
    .article-info {
      margin-top: 25px;
      height: 24px;
      line-height: 24px;
      color: #999;
      padding-left: 0;
      .time {
        padding-right: 25px;
      }
    }
    // --
    .audio-player {
      margin-top: 20px;
      audio {
        display: inline-block;
        vertical-align: baseline;
        width: 300px;
        height: 54px;
      }
    }
    .video-player{
      margin-top: 20px;
      video{max-width: 100%;display: block;}
    }
    .live-video-player{
      margin-top: 20px;
      /deep/ .video-js{width: 100%;height: 441px;}
      // /deep/ video{display: none;}
    }
    .live-audio-player{
      margin-top: 20px;height: 60px;background-color: #000;
      /deep/ audio{display: none;}
      /deep/ .video-js .vjs-control-bar{display: flex;height: 40px;background-color:transparent;top: 10px;width: 720px;margin: 0 auto;}
      /deep/ .video-js .vjs-icon-previous-item , /deep/ .video-js .vjs-icon-next-item{width: 40px;font-size: 25px;text-shadow: none;}
      /deep/ .video-js .vjs-icon-previous-item:hover , /deep/ .video-js .vjs-icon-next-item:hover{color: #0085cb;cursor: pointer;text-shadow: none;}
      /deep/ .video-js .vjs-icon-previous-item.none, /deep/ .video-js .vjs-icon-next-item.none{color: #999;cursor: auto;}
      /deep/ .video-js .vjs-play-control{width: 40px;height: 40px;border: 2px solid #fff;border-radius: 50%;text-shadow: none;}
      /deep/ .video-js .vjs-play-control:hover{border-color: #0085cb;}
      /deep/ .video-js .vjs-button > .vjs-icon-placeholder:before{font-size: 24px;line-height: 38px;}
      /deep/ .video-js .vjs-button > .vjs-icon-placeholder:hover{color: #0085cb;}
      /deep/ .video-js .vjs-live-control{line-height: 0px;}
      /deep/ .video-js .vjs-live-display{font-size: 12px;width: 34px;height: 14px;background-color: #0085cb;line-height: 14px;text-align: center;border-radius: 2px;position: absolute;top: 12px;left: 12px;}
      /deep/ .video-js .vjs-modal-dialog{display: none;}
    }
    .article-content {
      width: 100%;

      margin-top: 23px;
      padding: 0 10px;
      overflow: hidden;
      box-sizing: border-box;
      /deep/ p {
        padding: 0;
        line-height: 28px;
        padding-bottom: 16px;
        font-size: 16px;
      }
      //有 需要调整 不起作用
      /deep/ img {
        max-width: 100%;
        height: auto;
        // max-width:100%!important;
      }
    }
    .article-summary{
      margin-top: 20px;
      padding: 0 10px;
      overflow: hidden;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 28px;
    }
    // 分享
    .widget-share {
      display: flex;
      height: 21px;
      line-height: 21px;
      margin-top: 14px;
      position: relative;
      strong {
        // float: left;
        padding-right: 30px;
        font-weight: normal;
        color: #999;
        font-size: 14px;
      }
      a {
        cursor: pointer;
        width: 25px;
        height: 21px;
        margin-right: 15px;
        background: url("../../static/img/sprite-icon.png");
      }
      a.weixin {
        background-position: -300px 0px;
      }
      a.weixin:hover {
        background-position: -300px -30px;
      }
      a.weibo {
        background-position: -329px 0px;
      }
      a.weibo:hover {
        background-position: -329px -30px;
      }
      a.qq {
        background-position: -359px 0px;
      }
      a.qq:hover {
        background-position: -359px -30px;
      }
      .wxCode{position: absolute;z-index: 999;top: 30px;left: 50px;}
    }
    //评论相关
    .comment {
      margin-top: 34px;
      padding: 30px 0 0 0;
      border-top: solid 1px #dcdee3;
      .column-title {
        font-size: 28px;
        margin: 0;
        position: relative;
        padding-left: 10px;
        line-height: 30px;
        color: #000;
        font-style: normal;
        font-weight: normal;
      }
      .column-title:before {
        position: absolute;
        left: 0;
        top: 5px;
        display: block;
        content: "";
        width: 5px;
        height: 20px;
        border-radius: 2px;
        overflow: hidden;
        background-color: #f58431;
      }

      //@at-rootcomment-list
      .comment-list {
        padding: 0;
        // 无list 时候p的样式
        .comment-list-item {
          padding-top: 20px;
          border-top: dashed 1px #dcdee3;
          margin-top: 20px;

          //--
          .comment-list-img {
            width: 70px;
            height: 70px;
            float: left;
            overflow: hidden;
            border-radius: 50%;
            img {
              width: 70px;
              height: 70px;
              display: block;
            }
          }
          // ---有评论list
          .comment-list-txt {
            margin-left: 100px;
            .title {
              display: block;
              font-size: 18px;
              color: #666;
              margin-bottom: 10px;
            }
            p {
              font-size: 14px;
              line-height: 2em;
            }
            .info {
              margin-top: 14px;
              height: 22px;
              line-height: 22px;
              font-size: 14px;
              .time {
                float: right;
                color: #999;
              }
            }
          }
        }
        // --- 更多 btn
        .more {
          width: 134px;
          height: 52px;
          margin: 20px auto 0;
          border-radius: 5px;
          line-height: 52px;
          font-size: 14px;
          background-color: #31a9de;
          color: #fff;
          text-align: center;
        }
      }
    }
  }
  // 右侧内容
  .wrapRight {
    .spread {
      img {
        width: 464px;
        height: 148px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
// 移动端适配样式
@media screen and (max-width: 900px) {
  * {
    box-sizing: border-box;
  }
  .detail {
    background: #fff;
  }
  .detailCommorCont {
    width: 100%;
    padding: 0 10px;
    // margin: 0 auto;
    box-sizing: border-box;
  }
  .crumbs {
    display: none;
  }
  // 内容大块
  .sectionContent {
    display: block;
    // 内容左侧
    .wrapLeft {
      width: 100%;
      margin-right: 0;
      .article-title {
        font-size: 16px;
        line-height: 20px;
        font-weight: normal;
      }
      .article-info {
        margin-top: 10px;
        font-size: 0.24rem;
        .source {
          display: none;
        }
      }
      .audio-player {
        margin-top: 0.2rem;
        audio {
          display: inline-block;
          // width: 100%;
          height: 0.94rem;
        }
      }
      .video-player{
        margin-top: 0.2rem;
      }
      .live-video-player{
        margin-top: .2rem;
        .video-js{width: 100%;height: 3.6rem;}
      }
      //段落
      .article-content {
        width: 100%;
        padding: 0;
        margin-top: 0.16rem;
        /deep/ p {
          padding-bottom: 10px;
          font-size: 14px;
          line-height: 22px;
        }
      }
      .article-summary{
        width: 100%;
        padding: 0;
        margin-top: .16rem;
        font-size: 14px;
        line-height: 22px;
      }
      // comment
      .comment {
        padding-top: 0.2rem;
        margin-top: 0.22rem;
        .column-title {
          font-size: 0.23rem;
        }
        .comment-list {
          .comment-list-item {
            font-size: 0.24rem;
          }
        }
      }
    }

    //内容右侧
    .wrapRight {
      display: none;
      width: 100%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/Detail.vue